import React from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom'; // <-- Import Link
import { Globe, GraduationCap, DollarSign, TrendingUp, Heart } from 'lucide-react';
import './WhyChooseSection.css';

// Accept isLoggedIn as a prop
const WhyChooseSection = ({ isLoggedIn }) => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true
  };

  const featuresData = [
    {
      icon: <Globe className="wcs-card-icon-svg" />,
      image: 'photos/pop1.webp',
      title: ' Personalized AI Report',
      description: 'Receive an instant, data‑driven overview of your top 3–5 country‑university combinations, complete with program rankings and success odds',
    },
    {
      icon: <GraduationCap className="wcs-card-icon-svg" />,
      image: 'photos/pop2.webp',
      title: 'Seamless Visa Guidance',
      description: 'Get a clear, step‑by‑step roadmap—including document checklists, embassy bookings, and turnaround estimates—so you never miss a deadline.',
    },
    {
      icon: <DollarSign className="wcs-card-icon-svg" />,
      image: 'photos/pop3.webp',
      title: 'Scholarship & Funding Matches',
      description: 'Discover curated scholarship opportunities and financial aid options tailored to your profile, helping you minimize tuition and living costs.',
    },
    {
      icon: <TrendingUp className="wcs-card-icon-svg" />,
      image: 'photos/pop4.webp',
      title: 'Career Path Preview',
      description: 'Real-world salary data, job market trends, and PR options mapped for your chosen destination, so you can plan your future with confidence.',
    },
  ];

  return (
    <section className="wcs-section">
      <div className="wcs-container">
        <div className="wcs-header">
          <h2 className="wcs-main-title">Why Choose Get Next Visa?</h2>
          <p className="wcs-subtitle">
            Our AI-poweredplatform provides comprehensive insights to make your study abroad journey successful.
          </p>
        </div>

        {/* Slider for Mobile View (max-width: 425px) */}
        <div className="wcs-slider-mobile-view">
          <Slider {...sliderSettings}>
            {featuresData.map((feature, index) => (
              <div key={index} className="wcs-item-card" >
                <div className="wcs-card-top" style={{
                  backgroundImage: `url(${feature.image})`,
                }}>
                  <div className="wcs-card-icon-wrapper">
                    {feature.icon}
                  </div>
                </div>
                <div className="wcs-card-bottom">
                  <div className="wcs-card-text-area">
                    <h3 className="wcs-card-title">{feature.title}</h3>
                    <p className="wcs-card-desc">{feature.description}</p>
                  </div>
                  <Heart className="wcs-heart-icon" />
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* Grid for Desktop and Tablet View */}
        <div className="wcs-grid-desktop-view">
          {featuresData.map((feature, index) => (
            <div key={index} className="wcs-item-card" >
              <div className="wcs-card-top" style={{
                backgroundImage: `url(${feature.image})`,
              }}>
                <div className="wcs-card-icon-wrapper">
                  {feature.icon}
                </div>
              </div>
              <div className="wcs-card-bottom">
                <div className="wcs-card-text-area">
                  <h3 className="wcs-card-title">{feature.title}</h3>
                  <p className="wcs-card-desc">{feature.description}</p>
                </div>
                <Heart className="wcs-heart-icon" />
              </div>
            </div>
          ))}
        </div>
      </div>
        
      {/* --- MODIFICATION HERE --- */}
      {/* Conditionally render a Link or the original anchor tag based on login status */}
      {isLoggedIn ? (
        <Link 
          to="/dashboard?view=get-ai-report" 
          className="primary-btn" 
          aria-label="Get My Report"
          style={{ display: "flex", width: "fit-content", justifyContent: "center", margin: "0 auto", marginTop: "40px", cursor: "pointer" }}
        >
          Get My Report →
        </Link>
      ) : (
        <a 
          className="primary-btn trigger-login-popup" 
          aria-label="Get My Report"
          style={{ display: "flex", width: "fit-content", justifyContent: "center", margin: "0 auto", marginTop: "40px", cursor: "pointer" }}
        >
          Get My Report →
        </a>
      )}
    </section>
  );
};

export default WhyChooseSection;